import { render, staticRenderFns } from "./ProductsNoImage.vue?vue&type=template&id=1a9b4308&scoped=true&"
import script from "./ProductsNoImage.vue?vue&type=script&lang=ts&"
export * from "./ProductsNoImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsNoImage.vue?vue&type=style&index=0&id=1a9b4308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b4308",
  null
  
)

export default component.exports